// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gh-card--course[data-v-4edfc7b7]{cursor:default}", "",{"version":3,"sources":["webpack://./resources/assets/js/views/memberDashboard/components/courseCard.vue"],"names":[],"mappings":"AACA,kCACI,cAAA","sourcesContent":["\n.gh-card--course {\n    cursor: default;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
